import { useLocation } from "react-router-dom";

const useLanguagePrefix = () => {
  const location = useLocation();
  const supportedLanguages = ["en", "ro", "es", "de"];

  const pathParts = location.pathname.split("/").filter(Boolean);
  const currentLang = supportedLanguages.includes(pathParts[0]) ? pathParts[0] : null;

  return currentLang ? `/${currentLang}` : "";
};

export default useLanguagePrefix;
